export default {
  600: "Parameter error",
  510007: "No permission",
  510008: "Not logged in",
  510009: "User does not exist",
  510010: "System error, please try again later",
  510011: "Wrong platform parameter",
  510012: "Unauthorized access",
  510015:
    "The system is upgraded from 00:00-07:00. We are sorry for any inconvenience.",
  511001: "Graphic verification code error",
  511002: "Dynamic password error",
  511003: "Incorrect account or password",
  511004: "Your account has been suspended due to non-compliant operations!",
  511005: "User Token is missing",
  511006: "User token authentication failed",
  511007: "User Token has expired, please log in again",
  511008: "Data does not exist",
  511009: "Verification code error",
  511010: "User registration center registration failed",
  511011: "User already exists",
  511012: "Verification of previous step operation result failed",
  511013: "Old password cannot be empty",
  511014: "Old password error",
  511015: "Inconsistent password input",
  511016: "Malformed phone number",
  511017: "Email format error",
  511018: "Verification code error",
  511019: "Failed to send SMS verification code",
  511022: "Phone number already exists",
  511023: "E-mail already exists",
  511024: "Please do not repeat the request in a short time",
  511025: "Upload avatar exception",
  511026:
    "The third party user already exists. Please use the update interface to modify the data",
  511027: "The current user has been deleted, please restore first",
  511028: "Third party user don't exist",
  511032: "The password already exists, it's not allowed to be set directly",
  511033: "No permission",
  511034: "Invalid information",
  511036: "User already exists",
  511037: "The uploaded picture is too large",
  511038: "Upload file type is not supported",
  511039: "The current account is bound, please unbind it first",
  511041:
    "The third-party account information is missing, please scan the code again",
  511042: "Bound by another account",
  511043: "The number of interface visits reaches the upper limit",
  511044: "Data signature error",
  511045: "Data exception, the currently logged-in user does not exist",
  511046: "Signature parameter missing",
  511055: "Mobile phone number is not registered",
  511057: "Please enter the correct verification code",
  511058: "Invalid Token",
  511065: "The login request has expired, please log in again",
  511066: "Data signature error",
  511075: "Please fill in your mobile phone number",
  511076: "The data is being migrated, the page is temporarily unavailable",
  511078: "E-mail can not be left empty",
  511079: "Login prohibited, please contact customer service",
  511087: "User is not registered",
  512002: "This video is currently unavailable.",
  512017: "Whitelisted audience does not exist",
  512029: "This topic is not found.",
  512033: "Playback content does not exist",
  512037: "Whitelisted user does not exist",
  512042: "Image verification code error",
  512051: "Maximum concurrency of activities exceeds the limit",
  512063: "The topic is not found",
  512505: "No room found",
  512506: "live_token has expired",
  512507: "live_token is wrong or no longer valid",
  512514: "You have been banned from accessing the current activity",
  512515: "Participation data not found",
  512516: "The account has entered the live-streaming",
  512521: "The live-streaming has not started yet",
  512522:
    "The host, guests, or assistants are not allowed to enter the viewing terminal during the live-streaming",
  512523: "Need to pay",
  512524: "Live-streaming of the rebroadcast event has not started yet.",
  512525: "Fill in the registration form",
  512526:
    "The detection type and the activity viewing restriction type are inconsistent",
  512527: "Wrong password",
  512528: "Please enter the password",
  512529: "Wrong invitation code",
  512530: "The invitation code has been used",
  512531: "Please enter the invitation code",
  512532: "Please enter the phone/email/employee ID",
  512535: "The organizer has set up a verification mechanism for the event",
  512536: "Playback content does not exist",
  512538:
    "The organizer has set up a verification mechanism for the event, and the verification failed",
  512539:
    "The verification method only supports free, password and third-party K value",
  512540: "The event is over",
  512541:
    "The event site is too hit and the upper limit of audience has been exceeded!",
  512542: "Incomplete visitor data",
  512543: "This video is currently unavailable",
  512544:
    "This video is  currently unavailable, please contact customer service if you have any questions",
  512545: "The video failed to transcode",
  512546: "The video is being transcoded",
  512561: "Stream information does not exist",
  512570: "SMS verification code error",
  512571: "Data users owe more than 100G and cannot enter temporarily",
  512573: "E-mail has been used by others",
  512579: "Activity blocked by administrator",
  513025: "The wheat seat is full. Your account supports {n} people to wheat",
  513345:
    "Currently on display,video connection is temporarily unavailable,please try again late",
  513533: "Invalid participant token information",
  513534:
    "The current activity type does not match, the operation is prohibited",
  513535: "The host information is not obtained",
  513536: "Activity not match",
  513537: "No permission",
  513548: "Reward amount exceeds limit",
  513550: "Invalid image path",
  514004: "The current upload type contains a type that is not allowed",
  514005: "The current upload type is not allowed",
  514006: "Special characters in the upload path",
  514007: "Upload file does not exist",
  514008: "Upload file cannot exceed 2M",
  514009: "The uploaded file is too large",
  514014: "Authorization failed, please refresh and try again",
  516000: "System error, please try again later",
  516002: "User does not exist",
  516005: "Data signature error",
  516300: "Please bind your mobile phone",
  516301: "Verification code error",
  516305: "SMS verification code error",
  516307: "The withdrawal amount is at least  ¥1",
  516308: "Application amount can't be greater than account balance",
  516312: "Withdrawal in progress, unable to withdraw",
  516313:
    "If the maximum amount is exceeded, please apply for cash withdrawal offline",
  516820: "The withdrawal amount is at least  ¥1",
  516824: "Application amount can't be greater than account balance",
  516825: "User account balance is less than ¥0",
  516826: "Failed to send SMS verification code",
  516829: "Withdrawal failed",
};
